'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTES_V4 = exports.ROUTES = exports.BUSINESS_PARAMS = exports.CORPORATE_PARAMS = exports.BACKEND_HOST_MAP = undefined;

var _buildPathUrl = require('./utils/buildPathUrl');

var BACKEND_HOST_MAP = exports.BACKEND_HOST_MAP = {
  development: 'http://localhost:3000',
  E1: 'https://cardshop-dev.aexp.com',
  E2: 'https://cardshop-qa.americanexpress.com',
  E3: 'https://cardshop2.americanexpress.com'
};

var CORPORATE_PARAMS = exports.CORPORATE_PARAMS = {
  cardDetails: [
  // IT
  {
    countryCode: '',
    businessMarket: 'aziende',
    shopName: 'carte-di-pagamento-corporate',
    cardName: ''
  },
  // MX
  {
    countryCode: '',
    businessMarket: 'negocios',
    shopName: 'tarjetas-corporativas',
    cardName: ''
  },
  // FR
  {
    countryCode: '',
    businessMarket: 'entreprise',
    shopName: 'carte-de-paiement-corporate',
    cardName: ''
  },
  // JP
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'corporate-credit-cards',
    cardName: ''
  },
  // DE
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'firmenkreditkarten',
    cardName: ''
  }],
  compare: [
  // IT
  {
    countryCode: '',
    businessMarket: 'aziende',
    shopName: 'carte-di-pagamento-corporate',
    cardName: 'confronto'
  },
  // MX
  {
    countryCode: '',
    businessMarket: 'negocios',
    shopName: 'tarjetas-corporativas',
    cardName: 'comparar'
  },
  // FR
  {
    countryCode: '',
    businessMarket: 'entreprise',
    shopName: 'carte-de-paiement-corporate',
    cardName: 'comparer'
  },
  // JP
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'corporate-credit-cards',
    cardName: 'compare'
  },
  // DE
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'firmenkreditkarten',
    cardName: 'vergleich'
  }],
  viewAllCards: [
  // IT
  {
    countryCode: '',
    businessMarket: 'aziende',
    shopName: 'carte-di-pagamento-corporate'
  },
  // MX
  {
    countryCode: '',
    businessMarket: 'negocios',
    shopName: 'tarjetas-corporativas'
  },
  // FR
  {
    countryCode: '',
    businessMarket: 'entreprise',
    shopName: 'carte-de-paiement-corporate'
  },
  // JP
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'corporate-credit-cards'
  },
  // DE
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'firmenkreditkarten'
  }]
};

var BUSINESS_PARAMS = exports.BUSINESS_PARAMS = {
  cardDetails: [
  // IT
  {
    countryCode: '',
    businessMarket: 'aziende',
    shopName: 'carte-di-pagamento',
    cardName: ''
  },
  // MX
  {
    countryCode: '',
    businessMarket: 'negocios',
    shopName: 'tarjetas-negocios',
    cardName: ''
  },
  // FR
  {
    countryCode: '',
    businessMarket: 'entreprise',
    shopName: 'carte-de-paiement',
    cardName: ''
  },
  // JP
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'credit-cards',
    cardName: ''
  },
  // DE
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'kreditkarte',
    cardName: ''
  }],
  compare: [
  // IT
  {
    countryCode: '',
    businessMarket: 'aziende',
    shopName: 'carte-di-pagamento',
    cardName: 'confronto'
  },
  // FR
  {
    countryCode: '',
    businessMarket: 'entreprise',
    shopName: 'carte-de-paiement',
    cardName: 'comparer'
  },
  // DE
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'kreditkarte',
    cardName: 'vergleich'
  }],
  viewAllCards: [
  // IT
  {
    countryCode: '',
    businessMarket: 'aziende',
    shopName: 'carte-di-pagamento'
  },
  // FR
  {
    countryCode: '',
    businessMarket: 'entreprise',
    shopName: 'carte-de-paiement'
  },
  // JP
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'credit-cards'
  },
  // DE
  {
    countryCode: '',
    businessMarket: 'business',
    shopName: 'kreditkarte'
  }]
};

var ROUTES = exports.ROUTES = {
  CardDetailsSmallBusiness: (0, _buildPathUrl.build_v3_url)(BUSINESS_PARAMS.cardDetails),
  CardDetailsCorporate: (0, _buildPathUrl.build_v3_url)(CORPORATE_PARAMS.cardDetails),
  CompareSmallBusiness: (0, _buildPathUrl.build_v3_url)(BUSINESS_PARAMS.compare),
  CompareCorporate: (0, _buildPathUrl.build_v3_url)(CORPORATE_PARAMS.compare),
  ViewAllCardsSmallBusiness: (0, _buildPathUrl.build_v3_url)(BUSINESS_PARAMS.viewAllCards),
  ViewAllCardsCorporate: (0, _buildPathUrl.build_v3_url)(CORPORATE_PARAMS.viewAllCards)
};

var ROUTES_V4 = exports.ROUTES_V4 = {
  CardDetailsSmallBusiness: (0, _buildPathUrl.build_v4_url)(BUSINESS_PARAMS.cardDetails),
  CardDetailsCorporate: (0, _buildPathUrl.build_v4_url)(CORPORATE_PARAMS.cardDetails),
  CompareSmallBusiness: (0, _buildPathUrl.build_v4_url)(BUSINESS_PARAMS.compare),
  CompareCorporate: (0, _buildPathUrl.build_v4_url)(CORPORATE_PARAMS.compare),
  ViewAllCardsSmallBusiness: (0, _buildPathUrl.build_v4_url)(BUSINESS_PARAMS.viewAllCards),
  ViewAllCardsCorporate: (0, _buildPathUrl.build_v4_url)(CORPORATE_PARAMS.viewAllCards)
};